module.exports = __webpack_public_path__ + "img/avatar-36.0b68e714.svg";